export const faqFactory = (question, answer) => ({ question, answer: [ ...answer ] })

const faq = [
  faqFactory(
    'O que é inteligência artificial e como vocês usam isso no Manycontent?',
    [
      'Inteligência artificial é a capacidade das máquinas de através de sistemas executarem tarefas automaticamente e aprenderem sozinhas. Claro que estamos longe de perfeição, mas com a tecnologia de hoje já conseguimos fazer muitas coisas.',
      'No Manycontent nossos robôs inteligentes, analisam o seu perfil de empresa, negócio, concorrências e palavras chaves e buscamos em nossa própria base (que já tem muito aprendizado acumulado) e na Internet o tipo de conteúdo que mais pode ter chance de engajar sua audiência. Esse conteúdo é revisado por humanos jornalistas e enviado para sua revisão. Usamos inteligência artificial para analisar os posts, sugerir imagens, hashtags, etc. Quanto mais você usar o Manycontent mais ele irá aprender e com isso fornecer insights mais precisos.'
    ]
  ),
  faqFactory(
    'O conteúdo criado pode ser utilizado por outros usuários?',
    [
      'Não! A partir do momento que você aprova aquele conteúdo ele nunca mais será utilizado por outro usuário da mesma forma que foi apresentado. Os conteúdos são únicos, não são cópias de textos já prontos.'
    ]
  ),
  faqFactory(
    'E se eu não gostar do conteúdo criado?',
    [
      'Caso você não goste do conteúdo, você tem duas opções: a primeira é você mesmo editar o conteúdo, mudando o texto, imagens, hashtags, etc pelo nosso editor. Outra opção é você rejeitar o conteúdo, com isso nossos robôs vão criar um novo texto para você. Você pode rejeitar algumas vezes um conteúdo de acordo com seu plano.'
    ]
  ),
  faqFactory(
    'Quantos conteúdos vocês vão criar automaticamente para mim por mês?',
    [
      'O número de conteúdos criados automaticamente, variam de acordo com o plano selecionado. Por hora o único plano disponível é o Iniciante, que gera 8 posts por mês automaticamente para você. Além desses posts, você pode criar posts ilimitados manualmente usando o editor, que contém diversos recursos de imagem, sugestões de hashtag, etc.'
    ]
  ),
  faqFactory(
    'Por que eu estou tendo esse desconto vitalício, pagando apenas 70% do valor? Vale por quanto tempo?',
    [
      'Como nosso produto ainda é beta e por esse motivo, os primeiros usuários vão encontrar alguns bugs, ajudando nosso time a melhorar o produto, você merece ser recompensado por ser nosso usuário desde o começo. Se você assinar hoje conosco, pagará sempre 70% do valor do plano atual e de qualquer plano futuro que a gente venha a implementar, e isso nunca mais se repetirá.'
    ]
  ),
  faqFactory(
    'Por que não existe um plano para testar?',
    [
      'Na nossa estratégia de lançamento não temos estrutura suficiente para ter planos de teste, temos de focar nos nossos usuários alvos e melhorar para esse público que realmente estão alinhados com nossa missão. Além disso, quando a pessoa entra no Manycontent ela já tem conteúdos criados, revisados, imagens e editor pronto para o uso, o que já tem um valor agregado gigantesco. No futuro, quando crescermos vamos pensar em planos de teste por alguns dias, mas não temos previsão de ter essa modalidade nos próximos meses.'
    ]
  )
]

export default faq
